<div class="table-outer table-theme">
  <div class="table-responsive h-100">
    <p-table
      [value]="rows()"
      class="table-deals"
      [customSort]="true"
      (sortFunction)="customSort($event)"
      sortField="lot.name"
      [sortOrder]="1"
    >
      <ng-template #header>
        <tr>
          <th alignFrozen="right" pSortableColumn="prospect.firstName">
            Prospect
            <p-sortIcon field="prospect.firstName" />
          </th>
          <th class="text-center">Status</th>
          <th pSortableColumn="prospect.email">Contacts <p-sortIcon field="prospect.email" /></th>
          <th pSortableColumn="lot.name">Lot <p-sortIcon field="lot.name" /></th>
          <th pSortableColumn="modelElevation">Model & Elevation <p-sortIcon field="modelElevation" /></th>
          <th pSortableColumn="contractDate" class="text-center">Contract Date <p-sortIcon field="contractDate" /></th>
          <th pSortableColumn="targetClosingDate" class="text-center">
            Target Close <p-sortIcon field="targetClosingDate" />
          </th>
        </tr>
      </ng-template>
      <ng-template #body let-deal let-rowIndex="rowIndex">
        @if (rowIndex === 0 && recentDeals().length > 0) {
          <tr class="section-header-row">
            <td colspan="7" class="py-2 px-2">
              <div class="d-flex align-items-center gap-3">
                <span class="fs-10 fw-700 text-uppercase text-muted">Pick up where you left off</span>
                <span class="fs-10 fw-500 text-muted">{{ dealCountLabel(recentDeals().length) }}</span>
              </div>
            </td>
          </tr>
        }
        @if (rowIndex === recentDeals().length && recentDeals().length > 0 && otherDeals().length > 0) {
          <tr class="section-header-row">
            <td colspan="7" class="py-2 px-2">
              <div class="d-flex align-items-center gap-3">
                <span class="fs-10 fw-700 text-uppercase text-muted">Others</span>
                <span class="fs-10 fw-500 text-muted">{{ dealCountLabel(otherDeals().length) }}</span>
              </div>
            </td>
          </tr>
        }
        <tr class="cursor-pointer" title="ctrl + click to open in new tab" (click)="onRowClick($event, deal)">
          <td class="position-relative">
            <div class="d-flex align-items-center gap-2">
              <div class="d-flex align-items-center gap-2">
                <h6 class="mb-0 text-primary stretched-link text-decoration-underline">
                  {{ deal.prospect?.firstName }} {{ deal.prospect?.lastName }}
                </h6>
              </div>
            </div>
          </td>
          <td>
            <div class="d-flex flex-column gap-1 align-items-center">
              <lib-sign-status-badge [status]="deal.dealStatus.id"></lib-sign-status-badge>
              @if (deal.signedSignees != null && deal.totalSignees != null) {
                <span class="fs-12">{{ deal.signedSignees }} of {{ deal.totalSignees }} signed</span>
              }
            </div>
          </td>
          <td
            title="ctrl + click to open in new tab"
            style="width: 300px"
            (click)="onRowClick($event, deal)"
            class="fw-400"
          >
            <div class="d-flex align-items-center gap-2">
              <div class="align-items-center d-flex gap-2">
                <i class="bi bi-envelope text-primary lh-1"></i>
                <a
                  (click)="$event.stopPropagation()"
                  href="mailto:{{ deal.prospect?.email }}"
                  class="text-decoration-none text-primary"
                  >{{ deal.prospect?.email }}</a
                >
              </div>

              @if (deal.prospect?.phoneNumber) {
                <div (click)="$event.stopPropagation()" class="fs-14 fw-400 mb-0 text-gray-400">
                  <phone-numbers-display
                    [contacts]="[{ phoneNumber: deal.prospect?.phoneNumber, type: 'mobile' }]"
                  ></phone-numbers-display>
                </div>
              }
            </div>
          </td>
          <td>
            <app-lot-info-popup [lotId]="deal.lot.id ?? ''">
              <span class="text-decoration-underline">{{ deal.lot.name || '-' }}</span>
            </app-lot-info-popup>
          </td>
          <td>
            <div class="text-black">{{ deal?.model?.name }} ({{ deal?.elevation?.name }})</div>
          </td>
          <td class="text-center">{{ deal.contractDate ? (deal.contractDate | date: 'MM/dd/yyyy') : '-' }}</td>
          <td class="text-center">
            {{ deal.targetClosingDate ? (deal.targetClosingDate | date: 'MM/dd/yyyy') : '-' }}
          </td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="10" class="text-center py-4 text-muted">No APS found</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
